<template>
    <div>
        <navbar-menu></navbar-menu>
        <sidebar-menu></sidebar-menu>
        <router-view></router-view>
    </div>
</template>
<script>
import Navbar from '@/components/Navbar'
import Sidebar from '@/components/Sidebar'
import DropdownMixin from '@/mixins/dropdown'
import InactivityMixin from '@/mixins/inactivity'
export default {
    name:'MainLayout',
    mixins: [DropdownMixin, InactivityMixin],
    components:{
        'navbar-menu' : Navbar,
        'sidebar-menu' : Sidebar,
    }
}

</script>